// NATIVE 

// INSTALLED 

// CUSTOM 
import { checkingPreload, unCheckingPreload } from '../loading';
import { setSuscriptionRedux, setCustomerFormOptionsRedux, setSuscriptionsForSelectRedux, setPlansFormOptionsRedux } from './servicesIaCustomerSuscriptionsSlice';
import { QueryPagination } from '../../commons/interfaces';
import {
    getAllServicesIaCustomerSuscriptionsService,
    getServicesIaCustomerSuscriptionByIdService,
    saveServicesIaCustomerSuscriptionService,
    editServicesIaCustomerSuscriptionService,
    deleteServicesIaCustomerSuscriptionService,
    restoreServicesIaCustomerSuscriptionService,
    getServicesIaSuscriptionsFormService
} from '../../services/services-ia-customer-suscriptions.service';
import { getServicesIaPlansFormService } from 'services/services-ia-plans.service';

export const getAllServicesIaCustomerSuscriptionsStore =
    (query: QueryPagination = {}) =>
    async (dispatch: any) => {
        dispatch(checkingPreload());

        try {
            const response = await getAllServicesIaCustomerSuscriptionsService(query);

            if (response.ok) {
                dispatch(setSuscriptionsForSelectRedux(response.data));
            }

            return response;
        } catch (error) {
            console.error(error);

            return error;
        } finally {
            dispatch(unCheckingPreload());
        }
    };




export const getFormsSuscriptionsStore =
    () =>
    async (dispatch: any) => {
        dispatch(checkingPreload());

        try {
            const response = await getServicesIaSuscriptionsFormService();

            if (response.ok) { 
                await dispatch(setPlansFormOptionsRedux(response.data.plans));
                await dispatch(setCustomerFormOptionsRedux(response.data.customers));
            }

            return response;
        } catch (error) {
            console.error(error);

            return error;
        } finally {
            dispatch(unCheckingPreload());
        }
    };



export const getServicesIaCustomerSuscriptionByIdStore =
    (id: string) =>
    async (dispatch: any) => {
        dispatch(checkingPreload());

        try {
            const response = await getServicesIaCustomerSuscriptionByIdService(id);

            if (response.ok) {
                dispatch(setSuscriptionRedux(response.data)); 
                 await dispatch(setPlansFormOptionsRedux(response.data.plans));
            }

            return response;
        } catch (error) {
            console.error(error);

            return error;
        } finally {
            dispatch(unCheckingPreload());
        }
    };

export const saveServicesIaCustomerSuscriptionStore =
    (data: any) =>
    async (dispatch: any) => {
        dispatch(checkingPreload());

        try {
            const response = await saveServicesIaCustomerSuscriptionService(data);

            if (response.ok) {
                dispatch(setSuscriptionsForSelectRedux(response.data));
            }

            return response;
        } catch (error) {
            console.error(error);

            return error;
        } finally {
            dispatch(unCheckingPreload());
        }
    };

export const editServicesIaCustomerSuscriptionStore =
    (id: string, data: any) =>
    async (dispatch: any) => {
        dispatch(checkingPreload());

        try {
            const response = await editServicesIaCustomerSuscriptionService(id, data);

            return response;
        } catch (error) {
            console.error(error);

            return error;
        } finally {
            dispatch(unCheckingPreload());
        }
    };

export const deleteServicesIaCustomerSuscriptionStore =
    (id: string, query: QueryPagination = {}) =>
    async (dispatch: any) => {
        dispatch(checkingPreload());

        try {
            const response = await deleteServicesIaCustomerSuscriptionService(id, query);

            if (response.ok) {
                dispatch(setSuscriptionsForSelectRedux(response.data));
            }

            return response;
        } catch (error) {
            console.error(error);

            return error;
        } finally {
            dispatch(unCheckingPreload());
        }
    };

export const restoreServicesIaCustomerSuscriptionStore =
    (id: string, query: QueryPagination = {}) =>
    async (dispatch: any) => {
        dispatch(checkingPreload());

        try {
            const response = await restoreServicesIaCustomerSuscriptionService(id, query);

            if (response.ok) {
                dispatch(setSuscriptionsForSelectRedux(response.data));
            }

            return response;
        } catch (error) {
            console.error(error);

            return error;
        } finally {
            dispatch(unCheckingPreload());
        }
    };
